export default "__VITE_ASSET__Cul68Fa0__"